import i18n from 'locales/i18n';

export default function StepBox(props){
  const locale = i18n.language;

  const imgWidth= 45;

  return (
    <div className={`${props.className} flex flex-row items-center justify-between p-5  border-gray-300 border bg-white`}>
      <div className={`flex flex-col lg:max-w-[300px] mr-2`}>
        <p className="text-sm font-bold text-gray-900 lg:text-base">{props.title}</p>
        <p className="mt-2 text-xs text-gray-500 lg:text-sm" dangerouslySetInnerHTML={{__html:props.comment}}></p>
      </div>
      <div className={``}>
          <img src={props.img} style={{width:`${imgWidth}px`}} alt='business step'/>
      </div>
    </div>
  );
}